<template>
  <div class="review">
    <AnnotationContext></AnnotationContext>
  <kendo-splitter
    class="review-main"
    :panes="hSplitter1.panes"
    :orientation="hSplitter1.orientation"
    :scrollable="hSplitter1.scrollable">
    <kendo-splitter
      v-if="!this.$store.state.showAiAssistant"
      :panes="vSplitter1.panes"
      :orientation="vSplitter1.orientation"
      :scrollable="vSplitter1.scrollable">
        <SplitterContainer title="Decision (ID: 1234) - Progress 1 of 1 (100%)" component="ActionsManageStagesForms" :tag="true" :tagtitle="'Tags'" :swap="true" :swaptitle="'Swap'" :filter="true" :filtertitle="'Citations List'" :info="true" :infotitle="'Help & Shortcuts'" :detach="false"/>
        <SplitterContainer title="Annotations" component="Annotations"/>
    </kendo-splitter>
    <kendo-splitter
      v-if="this.$store.state.showAiAssistant">
        <PopupAiAssistant/>
    </kendo-splitter>
    <kendo-splitter
      :panes="vSplitter2.panes"
      :orientation="vSplitter2.orientation"
      :scrollable="vSplitter2.scrollable">
      <!-- Commented out Only for AI Demo, please uncomment whe showing the rest -->
      <!-- <kendo-splitter
        :panes="hSplitter2.panes"
        :orientation="hSplitter2.orientation"
        :scrollable="hSplitter2.scrollable">
        <SplitterContainer title="Citation" component="Citation" :aggregate="true" aggregatetitle="'Map to new study'" :edit="true" editable="true"/>
        <SplitterContainer title="Abstract" component="Abstract" editable="true"/>
      </kendo-splitter> -->
      <kendo-splitter
        :panes="hSplitter3.panes"
        :orientation="hSplitter3.orientation"
        :scrollable="hSplitter3.scrollable">
        <SplitterContainer title="Forms" component="Forms" :detach="true" :detachtitle="'Open Forms view in new window'" :assistant="true" :assistanttitle="'AI Data Entry Assistant'"/>
        <SplitterContainer title="Full Text" component="FullText" :swap="false" :detach="true" :detachtitle="'Open Full Text Review in new window'"/>
      </kendo-splitter>
    </kendo-splitter>
  </kendo-splitter>
  </div>
</template>

<script>
import SplitterContainer from '@/containers/SplitterContainer'
import AnnotationContext from '@/containers/AnnotationContext'
import PopupAiAssistant from '@/views/secure/cards/PopUpAiAssistant'

export default {
  name: 'review',
  components: {
    SplitterContainer,
    AnnotationContext,
    PopupAiAssistant
  },
  data () {
    return {
      highlightedtext: '',
      currentFocus: '',
      showAiAssistant: false,
      isProcess: false,
      hSplitter1: {
        scrollable: true,
        orientation: 'horizontal',
        height: '1000px',
        style: 'color: blue;',
        panes: [
          { collapsible: false, size: '40%' },
          { collapsible: true, size: '60%' }
        ]
      },
      vSplitter1: {
        scrollable: false,
        orientation: 'vertical',
        panes: [
          { collapsible: false, resizable: false }
        ]
      },
      vSplitter1Ai: {
        scrollable: false,
        orientation: 'vertical',
        panes: [
          { collapsible: false, size: '100%' }
        ]
      },
      vSplitter2: {
        scrollable: true,
        orientation: 'vertical',
        panes: [
          { collapsible: true, size: '30%' },
          { collapsible: true, size: '70%' }
        ]
      },
      hSplitter2: {
        scrollable: true,
        orientation: 'horizontal',
        panes: [
          { collapsible: false, size: '50%' },
          { collapsible: true, size: '50%' }
        ]
      },
      hSplitter3: {
        scrollable: true,
        orientation: 'horizontal',
        panes: [
          { collapsible: false, size: '50%' },
          { collapsible: true, size: '50%' }
        ]
      }
    }
  },
  mounted: function () {
    this.$store.state.selectedNavigation = 'batch-process'
    this.$store.state.selectedAction = 'manage-forms'
    this.$store.state.showActions = true
  }
}
</script>

<style>
  .k-widget .k-splitter {
    height: 850px !important;
  }

  .k-pane .k-scrollable {
    height: 850px !important;
  }
</style>
